import { maybe, rd } from '@passionware/monads';
import Account from '../../../../lib/auth/Account';
import { WithErrorService } from '../../front/ErrorService/ErrorService';
import { WithStudioService } from '../StudioService/StudioService';
import { ArrivalListService } from './ArrivalListService';
import { WithServices } from '../../../platform/ts/services';

export function createArrivalListService(
  config: WithServices<[WithErrorService, WithStudioService]>
): ArrivalListService {
  const { errorService, studioService } = config.services;
  const interceptor = errorService.withCategory('ArrivalListService');

  return {
    useArrivalList: interceptor.wrap(() => {
      const workspace = maybe.getOrThrow(
        Account.resolveFirstWorkspace(),
        'failed to find default workspace'
      );
      const tenant = maybe.getOrThrow(
        Account.tenant(),
        'failed to find tenant'
      );
      const domain = (tenant as any).web_url;
      const dbSchema = workspace.db_schema;

      const allStudiosOption = {
        studio: 'All Studios',
        portraitUrl: `${domain}/app/${dbSchema}/arrivals`,
        landscapeUrl: `${domain}/app/${dbSchema}/arrivals/landscape`
      };

      const studios = studioService.useStudioList();
      return rd.mapOrElse(
        studios,
        studios => {
          const studioList = studios.map(studio => ({
            studio: studio.name,
            portraitUrl: `${domain}/app/${dbSchema}/arrivals?studio=${studio.id}`,
            landscapeUrl: `${domain}/app/${dbSchema}/arrivals/landscape?studio=${studio.id}`
          }));

          return rd.of([...studioList, allStudiosOption]);
        },
        rd.of([allStudiosOption])
      );
    })
  };
}
